import React, { useEffect, useState } from 'react';
import Slider from "../components/slider";

export const LatestOutfit = ({languageData}) => {
  return(
    <div className="Latestoutfit_container">
      <div className="container">
        <div className="row py-5 px-lg-5">
          <h3 className="mb-5 text-white">Latest Outfits</h3>
          <div className="list_container">
            <Slider/>
          </div>
        </div>
      </div>
    </div>
  )
};
